import React, { useEffect, useState } from "react";
import Header from "../components/unauth/header/Header";
import Footer from "../components/unauth/footer/Footer";
import { IMAGE } from "../api/Image";
import Loading from "../components/unauth/loading/Loading";

export default function B2CLayout(props) {
  const { children } = props;
  const [open, setOpen] = useState(false);

  const [image, setImage] = useState(null);

  const getImageList = async () => {
    try {
      const res = await IMAGE.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch cake information");
      }
      setImage(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  useEffect(() => {
    getImageList();
  }, []);
  return (
    <>
      {image !== null && image !== undefined ? (
        <div className={`${open ? "fixed" : "relative"}`}>
          <div className="absolute w-full top-0">
            <Header setOpen={setOpen} open={open} image={image.heroImg} />
          </div>
          {children}
          <Footer />
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
}
